exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".antecedentes_container {\n  width: 100%;\n  padding-left: 0%;\n}\n\n.antecedentes_content {\n  display: flex;\n  width: 60%;\n}\n\n.antecedentes_container_indicadores {\n  display: flex;\n  padding-left: 2%;\n  flex: 1;\n}\n\n.antecedentes_container_indicadores .titulo {\n  color: #055e7a;\n}\n\n.antecedentes_label {\n  color: #055e7a;\n  font-weight: bolder;\n  margin-right: 3%;\n  margin-left: 5%;\n}\n\n.antecedentes_dato {\n  color: #0e7290;\n}\n\n.antecedentes_column {\n  margin-top: 2%;\n  flex: 1;\n}", ""]);

// exports
